/* eslint-disable @typescript-eslint/no-unused-vars */
import {useState, useContext} from "react";
import {Dialog} from "@material-ui/core"
import styles from '../../Payroll/Modals/PayrollModals.module.css'
import { useMutation } from "@apollo/client";
import { GET_PAYROLL_DISPERSION_2, 
         POST_AUTORIZA_OUTSORCERS, 
         POST_AUTORIZA_OUTSORCERS_EVENTUAL,
         GET_PAYROLL_DISPERSION_EVENTUAL,
         POST_AUTORIZA_OUTSORCERS_FINIQUITO,
         GET_PAYROLL_DISPERSION_FINIQUITO_OUT

        } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import OutsorcersNominaContext from "../../../context/OutsorcersNomina/OutsorcersNominaContext";
import { clearOutsorcers } from "../../../context/OutsorcersNomina/Actions";

const AutorizaOutsorcers = (props:any) =>{
  const {totalesDispersar, totales, seleccionados, idRegistro} = props
  const {state, dispatch} = useContext(OutsorcersNominaContext)
  const [activo, setactivo] = useState(false)
  const [activoMensajeDos, setactivoMensajeDos] = useState(false)
  const [mensaje, setMensaje] = useState('Uno')
  const [token, setToken] = useState('')
  
  const [sendDispersion] = useMutation(POST_AUTORIZA_OUTSORCERS,{
    refetchQueries:[
      {query: GET_PAYROLL_DISPERSION_2, variables:{getPayrollDispersionId: idRegistro}}
    ]
  })

  const [sendDispersionEventual] = useMutation(POST_AUTORIZA_OUTSORCERS_EVENTUAL,{
    refetchQueries:[
      {query: GET_PAYROLL_DISPERSION_EVENTUAL, variables:{getPayrollDispersionId: idRegistro}}
    ]
  })

  const [sendDispersionFiniquitoOut] = useMutation(POST_AUTORIZA_OUTSORCERS_FINIQUITO,{
    refetchQueries:[
      {query: GET_PAYROLL_DISPERSION_FINIQUITO_OUT, variables:{getPayrollDispersionId: idRegistro}}
    ]
  })

  const handleClose = () =>{
    clearOutsorcers({}, dispatch)
  }

  const handleChange = (e: any) =>{
    if(e.target.value === 'CONFIRMAR'){
        setactivo(true)
    }else{
        setactivo(false)
    }
  }

  const agregaSeleccionados = async() =>{
    setMensaje((current) => current = 'Dos')
    let Array:any = []
    seleccionados.map((lis:any)=>{
      Array.push({ id: parseInt(lis) })
    })
    switch (props.tipo) {
      case "eventual":
        await sendDispersionEventual({
          variables:{
            postAutorizaOutsorcersId: Array
          }
        })  
      break;
      
      case "Finiquito":
        await sendDispersionFiniquitoOut({
          variables:{
            postAutorizaOutsorcersId: Array
          }
        })  
      break;

      case "liquidacion":
        await sendDispersionFiniquitoOut({
          variables:{
            postAutorizaOutsorcersId: Array
          }
        })  
      break;      
    
      default:
        await sendDispersion({
          variables:{
            postAutorizaOutsorcersId: Array
          }
        })
        break;
    }


    props.reinicia()

    setactivo(false)
    setactivoMensajeDos((current) => current = false)
    SuccessfulAlert({text: "Registros enviados, por favor espera la respuesta"})
    setMensaje((current) => current ='Uno' )
    handleClose()
  }

  return(
    <Dialog aria-labelledby='costumized-dialog-title' open={state.openAutoriza} fullWidth={false} maxWidth={"md"}>
      <div className={styles.contenedorPrincipal}>
        <div className={styles.contenedorCerrarModal}>
          {mensaje === 'Tres'?
          null
          :
          <div
          className={styles.cerrarModal}
          onClick={()=> handleClose()}
        >
        </div>
          }

        </div>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.fim_iconoPrincipal}>
            <div className={styles.fim_iconoComplemento}>
            </div>
          </div>
        </div>
        <div className={styles.tituloAtencion}>
          ¡Atenci&oacute;n!
        </div>
        {mensaje === 'Uno'?
          <>
            <div className={styles.em_mensajePrtincipal}>
              Estas por autorizar monto a pagar no gravable
            </div>
          <div className={styles.em_mensajePrtincipal}>
            Escribe CONFIRMAR para continuar
          </div>
          <div>
              <input
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
          </div>
          </>
          :null
          }
          {mensaje === 'Dos'?
            <>
              <div className={styles.em_mensajePrtincipal}>
               La solicitud fue enviada, no actualices ni cierres la pantalla
              </div>
              <div className={styles.em_mensajePrtincipal}>
              hasta que el proceso haya terminado.
              </div>
              <div className={styles.contenedorLoadingDispersion}>
                <div className={styles.loading}></div>
              </div>
            </>
          : null
          }
        <div className={styles.em_contenedorBotones}>
              {mensaje === 'Dos'?
              null
              :
              <button
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
              }
              {mensaje === 'Uno'?
                (activo === true ?
                  <button 
                    className={`${styles.botonesAtencion} ${styles.continuarAtencion}`}
                    onClick={()=> agregaSeleccionados()}
                  >
                    <div>
                      Confirmar
                    </div>
                  </button>
                  :
                  <button
                    className={`${styles.botonesAtencion} ${styles.continuarAtencionInactivo}`}
                  >
                    <div>
                      Confirmar
                    </div>
                  </button>
                )
                :null
              }
            </div>
      </div>
    </Dialog>
  )
}

export default AutorizaOutsorcers